let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6eJxC")).then(() => parcelRequire('34To1'));